import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Typo from 'uikit/content/components/typo';

import styles from '../styles/uikitManageManageContentSectionHeader.module.scss';

const ManageContentSectionHeader = ({
  className = '',
  description = '',
  element = 'h3',
  extra = null,
  extraClassName = '',
  isFollowedByMagicForm = false,
  title,
}) => (
  <header
    className={classnames(
      styles.element,
      { [styles.isFollowedByMagicForm]: isFollowedByMagicForm },
      className,
    )}
  >
    <div className={styles.heading}>
      <Typo className={styles.title} element={element} variant="d01">
        {title}
      </Typo>
      {extra && <div className={classnames(extraClassName)}>{extra}</div>}
    </div>
    {description && (
      <Typo className={styles.description} variant="b01">
        {description}
      </Typo>
    )}
  </header>
);

ManageContentSectionHeader.propTypes = {
  className: PropTypes.string,
  element: PropTypes.string,
  extra: PropTypes.node,
  extraClassName: PropTypes.string,
  description: PropTypes.string,
  isFollowedByMagicForm: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default ManageContentSectionHeader;
